import React, {ComponentType, useState} from "react";
import SimpleDialog from "./index";
import {IHandlers, IProps, IServices, IContainerProps} from './types';
import { IBaseProps } from 'app/common/SimpleDialogMain/types'

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";

const NS = 'SimpleDialogContainer';

const basePropsKeys: string[] = keys<IBaseProps>();
const propsKeys: string[] = keys<IProps>();
const containerKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
   const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;

  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IContainerProps;
   const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;

       /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);


  if(!containerProps.isOpen)
  {
    props.isOpen = false;
  }

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {

  }

  return ReactUtilsService.containerWrap(
    <SimpleDialog {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ASimpleDialog: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerKeys] as never[], // no continer props needed
  servicesKeys
];
